import { ssdkScriptIds } from '../consts';

import { WebPosSalesSDK } from '@b2bsoft/web-pos-sales-sdk';


export const defaultInjectOptions = {
    ssdkScriptIds,
    webPosGlobalInstanceName: 'webPosSalesSdk',
    webPosConstructorName: 'SalesSDK',
}


export function createOptions(env) {
    return { ...defaultInjectOptions, ...env };
}

/**
 * Injection of WebPOS Sales SDK.
 * Downloads and injects Sales SDK script from options in env.
 * After injecting instantiated Sales SDK in window.
 * @param  {Object} [env=defaultInjectOptions] The inject options.
 */
export async function inject(env) {
    if (!env ||
        !env.webPosSalesSdkUrl ||
        !env.webPosSalesSdkTimeout
    ) {
        throw new Error('Inject settings are not defined');
    }

    const options = createOptions(env);
    const {
        webPosSalesSdkTimeout,
        webPosGlobalInstanceName,
    } = options;

    window[webPosGlobalInstanceName] = new WebPosSalesSDK(webPosSalesSdkTimeout);

}

export function initLoadedSalesSdk(options) {
    const {
        webPosGlobalInstanceName,
        webPosConstructorName,
        webPosSalesSdkTimeout,
    } = options;

    window[webPosGlobalInstanceName] = new window[webPosConstructorName](webPosSalesSdkTimeout);
}
